import { render } from "./daySquare.vue?vue&type=template&id=8cf212b4"
import script from "./daySquare.vue?vue&type=script&lang=js"
export * from "./daySquare.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__